import { timestamp } from 'drizzle-orm/pg-core';

export const defaultColumns = {
  createdAt: timestamp('createdAt').notNull().defaultNow(),
  updatedAt: timestamp('updatedAt')
    .notNull()
    .defaultNow()
    .$onUpdateFn(() => new Date()),
};
